import Flags from './Flags';

export default Flags;
